const imageModules = import.meta.glob('./*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const allImages = Object.entries(imageModules)
  .map(([path, src]) => ({ path, src: src as string }))
  .sort((a, b) => a.path.localeCompare(b.path));

const photoFiles = allImages.filter(i => !i.path.includes('km-'));

export const jizbiceImages: string[] = photoFiles.map(i => i.src);
